import { useCustomerAmendments } from '@/features/customers/hooks/useCustomerAmendments';
import { isListPanelFocusable } from '../utils/listPanelFocus';
import { useAgreementHolder } from './useAgreementHolder';
import type { Agreement } from '../types/agreements.types';

/** The agreement's Customer tab is a read surface; each change is its own page.
 *  The log is fetched only while the tab is open and a live record resolved. */
export function useAgreementCustomerTab(agreement: Agreement | undefined, isActive: boolean) {
    const holder = useAgreementHolder(agreement);
    // The log shares customer.read with the live read, so a refused read means
    // a refused log: it is not requested.
    const showsAmendments = holder.source === 'current';
    const amendments = useCustomerAmendments(holder.customerId, isActive && showsAmendments);

    return {
        ...holder,
        showsAmendments,
        amendments,
        focusablePanel: isListPanelFocusable({
            isLoading: showsAmendments && amendments.query.isLoading,
            isError: showsAmendments && amendments.query.isError,
            hasFocusableAction: holder.canChangeContactDetails || holder.canChangeName,
            lastPage: amendments.query.data?.meta.lastPage,
        }),
    };
}
